// extracted by mini-css-extract-plugin
export default {"sortDropdown":"components-Filter-themes-BGH-RD3-desktop-types-sort__sortDropdown--wgc7j","sortButton":"components-Filter-themes-BGH-RD3-desktop-types-sort__sortButton--gT44C"};